import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { StatusQueueEnum } from '../../enum/status-queue.enum';

@Component({
    selector: 'app-status-bullet',
    templateUrl: './status-bullet.component.html',
    styleUrls: ['./status-bullet.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusBulletComponent implements OnInit {

  @Input() idStatusQueue:number;
  @Input() statusQueueName:string;
  statusQueueEnumChamando:StatusQueueEnum = StatusQueueEnum.chamando;
  statusQueueEnumEm_atendimento:StatusQueueEnum = StatusQueueEnum.em_atendimento;


  constructor() { }

  ngOnInit(): void {
    
  }
}
